import { useState } from "react";
import { appPlatforms } from "@/mocks/home";

export default function AppDownload() {
  const [activeId, setActiveId] = useState(appPlatforms[0].id);
  const active = appPlatforms.find((p) => p.id === activeId) ?? appPlatforms[0];

  return (
    <section id="app" className="w-full bg-background-100 py-14 md:py-20">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="max-w-2xl">
          <span className="text-xs md:text-sm font-label tracking-widest text-primary-600 uppercase">
            App Download
          </span>
          <h2 className="mt-3 font-heading text-2xl md:text-4xl text-foreground-950">
            八戒影院 App 下载与安装指引
          </h2>
          <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-600">
            App 相比网页版更适合长期、频繁使用，但安装来源和系统权限更需要留意。
            切换到你的设备类型，查看对应的安装步骤和注意事项。
          </p>
        </div>

        <div className="mt-8 inline-flex flex-wrap gap-1 p-1 rounded-full bg-background-50 border border-background-200/70">
          {appPlatforms.map((platform) => {
            const isActive = platform.id === activeId;
            return (
              <button
                key={platform.id}
                type="button"
                onClick={() => setActiveId(platform.id)}
                aria-pressed={isActive}
                className={`inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm whitespace-nowrap cursor-pointer transition-colors ${
                  isActive
                    ? "bg-primary-500 text-background-50"
                    : "text-foreground-600 hover:bg-background-100"
                }`}
              >
                <i className={`${platform.icon}`} aria-hidden="true"></i>
                {platform.label}
              </button>
            );
          })}
        </div>

        <div className="mt-6 grid grid-cols-1 lg:grid-cols-3 gap-6">
          <div className="lg:col-span-2 p-5 md:p-6 rounded-lg bg-background-50 border border-background-200/70">
            <div className="flex items-center gap-3">
              <span className="w-11 h-11 rounded-md bg-accent-100 text-accent-900 flex items-center justify-center">
                <i className={`${active.icon} text-xl`} aria-hidden="true"></i>
              </span>
              <div>
                <h3 className="font-heading text-lg text-foreground-950">{active.label}</h3>
                <p className="text-xs text-foreground-500">安装步骤</p>
              </div>
            </div>

            <p className="mt-4 text-sm leading-relaxed text-foreground-600">{active.intro}</p>

            <ol className="mt-5 space-y-3">
              {active.steps.map((step, index) => (
                <li key={step} className="flex items-start gap-3">
                  <span className="flex-none w-6 h-6 rounded-full bg-primary-100 text-primary-700 text-xs font-medium flex items-center justify-center">
                    {index + 1}
                  </span>
                  <span className="text-sm text-foreground-700 leading-relaxed">{step}</span>
                </li>
              ))}
            </ol>
          </div>

          <div className="lg:col-span-1 p-5 md:p-6 rounded-lg bg-secondary-50 border border-secondary-200">
            <h4 className="font-heading text-base text-foreground-950">注意事项</h4>
            <ul className="mt-4 space-y-3">
              {active.notes.map((note) => (
                <li key={note} className="flex items-start gap-2 text-xs md:text-sm text-foreground-600">
                  <i className="ri-alert-line text-secondary-600 mt-0.5" aria-hidden="true"></i>
                  <span>{note}</span>
                </li>
              ))}
            </ul>

            <div className="mt-6 pt-5 border-t border-secondary-200">
              <h4 className="font-heading text-base text-foreground-950">还是打不开？</h4>
              <p className="mt-2 text-xs leading-relaxed text-foreground-600">
                如果你在安装过程中遇到跳转异常或来源不明的下载提示，建议直接回到官方公告重新获取入口。
              </p>
              <a
                href="#official"
                className="mt-4 inline-flex items-center gap-2 px-4 py-2.5 rounded-md bg-secondary-500 text-background-50 text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-secondary-600 transition-colors"
              >
                <i className="ri-shield-check-line" aria-hidden="true"></i>
                查看入口辨识方法
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}